import { render } from "./browse-spare-part-catalog.vue?vue&type=template&id=09e54858&ts=true"
import script from "./browse-spare-part-catalog.vue?vue&type=script&lang=ts"
export * from "./browse-spare-part-catalog.vue?vue&type=script&lang=ts"

import "./browse-spare-part-catalog.vue?vue&type=style&index=0&id=09e54858&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__